import { RolloutTemplateParameter } from "../../../Types";

/**
 * Validates a rollout form field. Add more rules as needed for your rollout form.
 * @param name Field name
 * @param value Field value
 * @param parameters The template parameters array (for context)
 * @returns Error string or empty string/null if valid
 */
export function validateRolloutField(
  name: string,
  value: any,
  parameters?: RolloutTemplateParameter[],
): string | null {
  // Example: Required validation for all fields except booleans
  const param = parameters?.find((p: { name: string }) => p.name === name);
  if (!param) return null;
  if (
    param.type !== "boolean" &&
    (value === undefined || value === null || value === "")
  ) {
    return "Required";
  }
  // Special validation for RolloutAndProgressionType
  if (name === "RolloutAndProgressionType" && typeof value === "string") {
    const [, mode, progression] = value.split("_");
    if (progression === "Manual" && mode !== "SDP") {
      return `Manual is not applicable to mode ${mode}. Automatic will be used instead.`;
    }
  }
  // Add more custom rules as needed
  return null;
}
